import CommunicationComposer, { type RecipientGroup } from '../../communications/CommunicationComposer';
import CommunicationStandortHint from '../../communications/CommunicationStandortHint';
import type { SelectedTeilnehmerState } from './types';

type StepCommunicationProps = Readonly<{
  isActive: boolean;
  selectedStandortId?: number;
  composerGroups: RecipientGroup[];
  setSkipStudentEmail: (skip: boolean) => void;
  setSkipTeacherEmail: (skip: boolean) => void;
  setSkipStudentSms: (skip: boolean) => void;
  setSkipTeacherSms: (skip: boolean) => void;
  trialRequestId?: number;
  createPerson: boolean;
  selectedTeilnehmer: SelectedTeilnehmerState | null;
  /** Was im Schritt tatsächlich steht — das soll auch verschickt werden (T-0032). */
  onDrafts?: (entwuerfe: Record<string, { subject: string; html: string; text: string; sms: string }>) => void;
}>;

const StepCommunication = ({
  isActive,
  selectedStandortId,
  composerGroups,
  setSkipStudentEmail,
  setSkipTeacherEmail,
  setSkipStudentSms,
  setSkipTeacherSms,
  trialRequestId,
  createPerson,
  selectedTeilnehmer,
  onDrafts,
}: StepCommunicationProps) => {
  const standortId = Number(selectedStandortId);
  const hasValidStandort = Number.isFinite(standortId) && standortId > 0;

  return (
    <div className="space-y-3">
      {composerGroups.length > 1 ? (
        <div className="rounded-md border bg-muted/20 px-3 py-2 text-sm">
          <span className="font-medium">Benachrichtigungen:</span> Wähle oben zwischen <span className="font-medium">Lehrer</span> und <span className="font-medium">Teilnehmer</span>.
        </div>
      ) : null}
      {composerGroups.length > 0 && hasValidStandort && (
        <CommunicationComposer
          active={isActive}
          standortId={standortId}
          groups={composerGroups}
          onDraftsChange={({ groups: g }) => {
            const student = g.student;
            const teacher = g.teacher;
            if (student) setSkipStudentEmail(!student.selectedChannels.email);
            if (teacher) setSkipTeacherEmail(!teacher.selectedChannels.email);
            if (student) setSkipStudentSms(!student.selectedChannels.sms);
            if (teacher) setSkipTeacherSms(!teacher.selectedChannels.sms);
            onDrafts?.(
              Object.fromEntries(
                Object.entries(g).map(([key, wert]) => [
                  key,
                  {
                    subject: wert.email.subjectTpl || '',
                    html: wert.email.htmlTpl || '',
                    text: wert.email.textTpl || '',
                    sms: wert.sms.smsTpl || '',
                  },
                ])
              )
            );
          }}
        />
      )}
      {composerGroups.length > 0 && !hasValidStandort ? (
        <CommunicationStandortHint />
      ) : null}
      {!trialRequestId && createPerson && !selectedTeilnehmer ? (
        <div className="text-xs text-muted-foreground">
          Hinweis: Bei neu anzulegenden Personen können Kontaktwege erst nach dem Speichern aufgelöst werden. Die Benachrichtigung wird dann anhand der gespeicherten Kontaktangaben versendet.
        </div>
      ) : null}
    </div>
  );
};

export default StepCommunication;
